import { APP_NAMES } from "@constants/Enums";

type UserAppsInfoCardProps = {
  apps: any[];
  selectedApps: any[];
  handleCheckboxChange: (app: any) => void;
  sortApps: (apps: any[]) => any[];
  error_message: { user: { no_apps: string } };
};

export const UserAppsInfoCard = ({
  apps,
  selectedApps,
  handleCheckboxChange,
  sortApps,
  error_message,
}: UserAppsInfoCardProps) => {
  return (
    <div>
      <div className="mt-5 divider" />
      <h3 className="mt-10 mb-5 label-light-blue-xl">利用アプリ</h3>
      <div className="mb-2 text-xl text-black flex flex-wrap gap-5">
        {apps.length > 1 ? (
          (sortApps?.(apps ?? []) ?? [])
            .filter((app) => app.name !== APP_NAMES.WORKJOY)
            .map((app) => (
              <label key={app.id} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  className="w-4 h-4 accent-blue-600"
                  checked={selectedApps?.some((a) => a.id === app.id)}
                  onChange={() => handleCheckboxChange(app)}
                />
                {app.name}
              </label>
            ))
        ) : (
          <div>{error_message.user.no_apps}</div>
        )}
      </div>
      <div className="mt-5 divider" />
    </div>
  );
};
